var _style, _rect, _polygon, _path, _polygon2, _path2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRimsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158.3 47",
    style: {
      enableBackground: "new 0 0 158.3 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#25509F;}\n\t.st1{fill:#EB5F40;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 8,
    className: "st0",
    width: 4.1,
    height: 31.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.5,40.1 77.3,18.7 77.4,18.7 81.3,39.4 85.5,39.4 78.8,6.7 67.5,31.4 56.2,6.7 49.5,39.4 53.7,39.4  57.6,18.7 57.7,18.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,12.1c-1.8-3-4.8-4.7-8.4-4.7c-5,0-9.7,3-9.7,8.1c0,4.4,3.4,6.4,7.1,8l2.3,0.9c2.8,1.1,5.7,2.6,5.7,6 c0,3.3-2.5,6.1-6.1,6.1c-3.5,0-6.4-2.5-6.4-6l-4.1,0.8c0.7,5,4.8,8.8,10.1,8.8c5.9,0,10.5-4.1,10.5-9.8c0-5.2-3.5-7.7-8.1-9.5 l-2.4-0.9c-2-0.8-4.6-2-4.6-4.5c0-2.7,2.9-4.5,5.5-4.5c2.5,0,4,1,5.3,2.9L116,12.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "136.8,28 142.7,15.3 148.5,28 150.2,31.6 153.9,39.4 158.3,39.4 142.7,6.7 127,39.4 131.4,39.4  135.1,31.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,22.9l0-11.4h1.5c4,0,8.9,0.7,8.9,5.6c0,3.9-2.5,4.9-5,5.4l7.3,16.9h4.4l-7.4-14.6c2.9-1.5,4.6-4.4,4.6-7.8 c0-3-1.6-5.9-4.3-7.5C11,8.1,7.9,8,5,8H0v31.4h3.7V26.1L3.7,22.9z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "142.6,23 150.7,47 134.5,47 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68,24.1 60.1,0 75.9,0 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRimsa);
export default __webpack_public_path__ + "static/media/rimsa.34f70043dc981da077e2f39ccd965ebb.svg";
export { ForwardRef as ReactComponent };